import React from "react";

import styles from "./layout.module.scss";

export const FormTitle = ({ children }) => {
	return <div className={styles.formTitle}>{children}</div>;
};
